<template>
	<div id="notes">
		<h3 class="headline">{{headline || 'Notizen'}}</h3>
		<input type="text"
			   :disabled="disabled"
			   v-model="title"
			   v-on:change="onTitleChange"
			   placeholder="Titel">

		<div class="editor">
			<editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
				<div class="menubar">
					<button
							class="button boldButton"
							:class="{ 'button-active': isActive.bold() }"
							@click="commands.bold">B
					</button>

					<button
							class="button italicButton"
							:class="{ 'button-active': isActive.italic() }"
							@click="commands.italic">I
					</button>
				</div>
			</editor-menu-bar>
			<editor-content :editor="editor" class="textArea"
							:class="{ 'textArea large': largeTextArea }"/>
		</div>

	</div>
</template>

<script>
	import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
	import {Bold, Italic} from 'tiptap-extensions';
	import {EventBus} from '@/services/EventBus.js';

	export default {
		name: "Notes",
		components: {
			EditorContent,
			EditorMenuBar,
		},
		props: [
			"title",
			"text",
			"headline",
			"disabled",
			"largeTextArea"
		],
		watch: {
			text: function (newText) {
				this.onTextChange(newText);
			}
		},
		data() {
			return {
				inputTitle: '',
				inputText: '',
				editor: new Editor({
					editorProps: {},
					editable: true,
					content: this.text,
					extensions: [
						new Bold(),
						new Italic()
					],
					onUpdate: ({getHTML}) => {
						this.onTextChange(getHTML());
					}
				})
			}
		},
		methods: {
			onTitleChange() {
				this.inputTitle = this.title;
				this.$emit('update:title', this.inputTitle);
			},
			onTextChange(newText) {
				this.inputText = newText;
				this.$emit('update:text', this.inputText);
			}
		},
		mounted() {
			this.inputTitle = '';
			this.inputText = '';

			EventBus.$on('onUpdateText', text => {
				if (this.text == null) {
					this.text = text;
				} else {
					this.text = this.text + text;
				}

				this.inputText = this.text;
				this.editor.setContent(this.text);
			});
		},
		beforeDestroy() {
			this.editor.destroy()
		}
	}
</script>

<style>
	input {
		width: 100%;
		height: 40px;
		font-family: "BrownLLWeb-Regular";
		font-style: normal;
		font-size: 20px;
		padding: 5px 10px 5px 10px;
		margin-bottom: 20px;
	}

	.headline {
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.textArea div {
		width: 100%;
		height: 100%;
		padding: 5px 10px 5px 10px;
		white-space: normal;
		outline: none;
	}

</style>

<style scoped>
	.textArea {
		width: 100%;
		height: 220px;
		border: 1px solid black;
		font-family: "BrownLLWeb-Regular";
		font-style: normal;
		font-size: 20px;
		outline: none;
		overflow-y: auto;
	}

	.large {
		height: 292px;
	}

	.menubar {
		width: 100%;
		height: 40px;
		display: flex;
		border-left: 1px solid black;
		border-top: 1px solid black;
		border-right: 1px solid black;
	}

	.menubar .boldButton, .menubar .italicButton {
		width: 40px;
		margin: 0px;
		border: none;
	}

	.menubar .boldButton {
		font-family: "BrownLLWeb-Bold";
		font-weight: bold;
	}

	.menubar .italicButton {
		font-family: "BrownLLWeb-Regular";
		font-style: italic;
	}

	.menubar .button-active {
		color: white;
		background-color: black;
	}
</style>